import { FormEvent, useState } from 'react'
import { isSupabaseConfigured, supabase } from '../supabase'

export function LoginScreen() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError('')

    if (!isSupabaseConfigured) {
      setError('Supabase não configurado. Verifique o arquivo client/.env e gere o build novamente.')
      return
    }

    setLoading(true)
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password,
      })

      if (error) {
        const message = /invalid login credentials/i.test(error.message)
          ? 'E-mail ou senha inválidos.'
          : error.message
        setError(message)
      }
    } catch (err: any) {
      setError(err?.message || 'Não foi possível conectar ao serviço de autenticação.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-[#19191B] flex items-center justify-center p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-[#2A2A2D] rounded-2xl shadow-2xl border border-[#4A4A4F] p-5 sm:p-8"
      >
        <img src="/images/logo-dark.png" className="h-11 sm:h-14 mx-auto mb-5 sm:mb-6" alt="Seridóplast" />

        <h1 className="text-xl sm:text-2xl font-bold text-center text-white mb-2">Entrar</h1>
        <p className="text-sm text-center text-gray-400 mb-6">
          Acesse sua conta para continuar sua conferência de imagens.
        </p>

        <label className="block text-sm font-medium mb-2 text-gray-200">E-mail</label>
        <input
          type="email"
          required
          autoComplete="email"
          autoCapitalize="none"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="w-full mb-4 px-4 py-3 rounded-lg border border-[#5A5A60] bg-[#202023] text-white outline-none focus:border-[#FCD016]"
        />

        <label className="block text-sm font-medium mb-2 text-gray-200">Senha</label>
        <input
          type="password"
          required
          autoComplete="current-password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="w-full mb-4 px-4 py-3 rounded-lg border border-[#5A5A60] bg-[#202023] text-white outline-none focus:border-[#FCD016]"
        />

        {error && (
          <div className="mb-4 rounded-lg border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-300">
            {error}
          </div>
        )}

        <button
          disabled={loading}
          className="w-full bg-[#FCD016] hover:bg-[#FFD52A] text-[#18181A] font-semibold py-3 rounded-lg disabled:opacity-60 transition-colors"
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  )
}
